export interface ConnectionMetrics {
  attemptStartTime: number | null
  establishedTime: number | null
  firstMessageTime: number | null
  lastFailureReason: string
  totalAttempts: number
  successfulConnections: number
  totalReconnections: number
  backoffAttemptCount: number
}

export class WebSocketMetrics {
  private metrics: ConnectionMetrics

  constructor() {
    this.metrics = {
      attemptStartTime: null,
      establishedTime: null,
      firstMessageTime: null,
      lastFailureReason: '',
      totalAttempts: 0,
      successfulConnections: 0,
      totalReconnections: 0,
      backoffAttemptCount: 0,
    }
  }

  update(updates: Partial<ConnectionMetrics>): void {
    Object.assign(this.metrics, updates)
    if (import.meta.env.DEV) {
      console.warn('[WS Metrics]', updates)
    }
  }

  getStats(): ConnectionMetrics {
    return { ...this.metrics }
  }

  reset(): void {
    this.metrics = {
      attemptStartTime: null,
      establishedTime: null,
      firstMessageTime: null,
      lastFailureReason: '',
      totalAttempts: 0,
      successfulConnections: 0,
      totalReconnections: 0,
      backoffAttemptCount: 0,
    }
  }
}
